import React from 'react';
import Main from '~/components/Main';
const PagesMain = () => {
    return React.createElement(Main, null);
};
export default PagesMain;
